
import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { Observable } from 'rxjs';
import { OptimizePlanRequest, UnCommitPlanRequest } from "../../domain";
import { PlansRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class UnCommitPlanUsecase implements UseCase<UnCommitPlanRequest, boolean> {

  constructor(private readonly planRepository: PlansRepository) {
  }

  execute(params: UnCommitPlanRequest): Observable<boolean> {
    return this.planRepository.unCommitPlan(params);
  }

}
